import { useContext } from 'react';

import { CurrentTenantContext } from '@/contexts/current-tenant-context';

export const useCurrentTenant = () => {
  const context = useContext(CurrentTenantContext);
  if (!context) {
    throw new Error(
      'useCurrentTenant must be used within a CurrentTenantContext',
    );
  }
  return context;
};
